import React from 'react';
import { Box, Button, Container, Grid, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';

const HeroSection = ({ scrollToSection, navigate, isTransitioning }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ pt: 12, pb: 8, position: 'relative', zIndex: 1 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={7}>
            <Typography
              variant={isMobile ? 'h3' : 'h2'}
              sx={{ fontWeight: 800, mb: 3, color: '#000000', textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
            >
              Extract, Verify, and Improve — At Document Scale
            </Typography>
            <Typography variant="h6" sx={{ color: '#333333', mb: 4, lineHeight: 1.6, textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              Define extraction flows, run tasks against any PDF or image, verify results with evaluation policies, and fine-tune models — all in one platform.
            </Typography>
            <Stack direction="row" spacing={2} flexWrap="wrap">
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate('/registration')}
                sx={{
                  borderRadius: 3,
                  px: 4,
                  py: 1.5,
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  background: 'linear-gradient(45deg, #1976d2, #1565c0)',
                  boxShadow: '0 6px 20px rgba(25, 118, 210, 0.4)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #1565c0, #1976d2)',
                    boxShadow: '0 8px 25px rgba(25, 118, 210, 0.6)',
                    transform: 'translateY(-3px)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Get Started
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={scrollToSection}
                sx={{
                  borderRadius: 3,
                  px: 4,
                  py: 1.5,
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  border: '2px solid rgba(25, 118, 210, 0.6)',
                  color: '#1976d2',
                  background: 'rgba(25, 118, 210, 0.05)',
                  '&:hover': {
                    background: 'rgba(25, 118, 210, 0.1)',
                    border: '2px solid rgba(25, 118, 210, 0.8)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 20px rgba(25, 118, 210, 0.3)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Learn More
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;
